import { render, staticRenderFns } from "./DescriptionCard.vue?vue&type=template&id=944e52cc"
import script from "./DescriptionCard.vue?vue&type=script&lang=js"
export * from "./DescriptionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports